import { RuleCreatePageKey, RuleListPageKey } from '../../TModules';

export const translations = {
  [RuleListPageKey]: {
    SearchPlaceholder: 'Search rule by name or ID',
    ApproveRequests: 'Approve requests',
    CreateRule: 'Create Rule',
    Rules: 'Rules',
    RuleActivatedSuccessfully: 'Rule activated successfully.',
    ActivationRequestSubmittedForApproval: 'Activation request submitted for approval.',
    RuleDeactivatedSuccessfully: 'Rule deactivated successfully.',
    RuleDeactivationRequestSubmittedForApproval:
      'Rule deactivation request submitted for approval.',
    MultipleApproveRequestSuccessMessage: 'Multiple approve request submitted for approval.',
    ErrorApprovingRewards: 'Error approving rewards.',
    ApproveMultipleRequests: 'Approve multiple requests?',
    ApproveSelected: 'Approve selected',
    ApproveMultipleRequestsMessageLineOne:
      'Are you sure you want to approve all the selected requests?',
    ApproveMultipleRequestsMessageLineTwo:
      'Please verify the details before approving as this action cannot be undone.',
    ApproveRequestSuccessMessage: 'Approve request success message.',
    SomethingWentWrong: 'Something went wrong.',
    ApproveRuleTitle: 'Approve rule?',
    SubmitDeletionRequestTitle: 'Submit deletion request?',
    Approve: 'Approve',
    RequestDeletion: 'Request deletion',
    ApproveRuleMessageLineOne: 'Are you sure you want to approve this rule?',
    ApproveRuleMessageLineTwo: 'This action cannot be undone.',
    SubmitDeletionRequestMessageLineOne:
      'This rule is pending approval. Are you sure you want to delete it?',
    SubmitDeletionRequestMessageLineTwo:
      'Once the deletion is approved, this rule will not be available and you will need to create it again.',
    Tabs: {
      All: 'All',
      Scheduled: 'Scheduled',
      Active: 'Active',
      Inactive: 'Inactive',
      Ended: 'Ended',
      Pending: 'Pending'
    },
    Columns: {
      RuleName: 'Rule Name',
      Status: 'Status',
      Comment: 'Comment',
      RequestType: 'Request Type',
      Balance: 'Balance',
      StartDate: 'Start Date',
      EndDate: 'End Date',
      Trigger: 'Trigger',
      Outcome: 'Outcome',
      Actions: 'Actions',
      ID: 'ID',
      Rule: 'Rule',
      Multiple: 'Multiple'
    },
    Errors: {
      ErrorActivatingRule: 'Error activating rule',
      ErrorDeactivatingRule: 'Error deactivating rule'
    },
    Actions: {
      Show: 'Show',
      Approve: 'Approve',
      Review: 'Review',
      Activate: 'Activate',
      Deactivate: 'Deactivate',
      Duplicate: 'Duplicate',
      Edit: 'Edit'
    },
    CampaignRuleModal: {
      Create: 'Create Campaign Rule',
      Edit: 'Edit Campaign Rule',
      OkText: 'Add',
      UpdateText: 'Update',
      RuleName: 'Rule name',
      RuleType: 'Rule type',
      RuleGetsTriggeredIf: 'Rule gets triggered if:',
      Priority: 'Priority',
      RuleOutcome: 'Rule outcome',
      OutcomeType: 'Outcome type',
      OutcomeValue: 'Outcome value',
      OutcomeValuePlaceholder: 'Enter outcome value'
    },

    RuleTriggerLimitSegment: {
      TriggerLimits: 'Trigger limits',
      TotalNumberOfTriggerEvents: 'Total number of trigger events (on campaign level)',
      TriggerLimit: 'Trigger limit',
      TriggerLimitPlaceholder: '∞',
      TotalNumberOfTriggerEventsPerUser: 'Total number of trigger events (per user)',
      TriggerRateLimitPerUser: 'Trigger rate limit (per user)',
      LeaveTheLimitFieldsBlankForUnlimitedTriggerEvents:
        'Leave the limit fields blank for unlimited trigger events',
      Days: 'Days',
      Weeks: 'Weeks',
      Months: 'Months',
      Years: 'Years',
      TriggerEventsForEvery: 'trigger event(s)^ for every'
    },

    TransactionalFields: {
      ChooseOne: 'Choose One...',
      SelectTrigger: 'Select Trigger',
      SelectOperator: 'Select Operator',
      AddCondition: 'Add Condition',
      FromDate: 'From Date',
      ToDate: 'To Date',
      And: 'And'
    },

    PersonalPropertyFilterField: {
      WhereHeader: 'WHERE profile changes include',
      InfoNote:
        'The rule will only trigger when the profile update changes ALL specified keys to their specified values.',
      Key: 'Key',
      Value: 'Value',
      Operator: 'Operator',
      KeyPlaceholder: 'key',
      ValuePlaceholder: 'value',
      SelectOperator: 'Select Operator',
      PleaseSeparateValuesUsingComma: 'Please separate multiple values using comma',
      AttributeLabel: 'Personal property',
      Equals: 'Equals',
      NotEquals: 'Not equals',
      In: 'In',
      NotIn: 'Not in',
      Like: 'Like',
      NotLike: 'Not like',
      KeyRequired: 'Property key is required',
      OperatorRequired: 'Operator is required',
      OperatorInvalid: 'Operator is required',
      ValueRequired: 'Value is required'
    },
    TransactionPropertyField: {
      PropertyDataType: 'Property data type',
      Key: 'Key',
      Sunday: 'Sunday',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Value: 'Value',
      PleaseSeparateMultipleValuesUsingComma: 'Please separate multiple values using comma',
      SelectOperator: 'Select Operator',
      Loading: 'Loading...',
      TableName: 'Table Name',
      Type: 'Type',
      SampleValues: 'Sample Values',
      Operator: 'Operator'
    },
    AutomationFields: {
      SelectTrigger: 'Select Trigger',
      ChooseOne: 'Choose one...',
      OutcomeType: 'Outcome type',
      SelectTriggerPlaceholder: 'Please select a trigger'
    },

    MerchantRewardSelectField: {
      SelectMerchant: 'Select a Merchant',
      Edit: 'Edit',
      Add: 'Add',
      Merchant: 'Merchant'
    },

    MerchantSelectModal: {
      Title: 'Select a Merchant',
      AddMerchant: 'ADD MERCHANT',
      Cancel: 'CANCEL',
      SearchPlaceholder: 'Search merchant by name or ID',
      Active: 'Active',
      Inactive: 'Inactive',
      Name: 'Name',
      Status: 'Status',
      DateCreated: 'Date Created',
      ID: 'ID'
    },

    RewardSelectField: {
      SelectReward: 'Select a Reward',
      Edit: 'Edit',
      Add: 'Add',
      Reward: 'Reward'
    },

    RewardSelectModal: {
      Title: 'Select a Reward',
      AddReward: 'Add Reward',
      Cancel: 'Cancel',
      SearchPlaceholder: 'Find a reward by name, id or merchant',
      All: 'All',
      Active: 'Active',
      Approved: 'Approved',
      Private: 'Private',
      System: 'System',
      Merchant: 'Merchant',
      Balance: 'Balance',
      SellingFrom: 'Selling from',
      SellingTo: 'Selling to',
      Reward: 'Reward',
      RewardName: 'Reward Name',
      ID: 'ID'
    }
  },
  [RuleCreatePageKey]: {
    LoadingRule: 'Loading Rule',
    Steps: {
      SetupRule: 'Setup Rule',
      SetupAudience: 'Setup Audience',
      Review: 'Review'
    },
    EditMessage: {
      MakerCheckerSuccess: 'Request submitted for approval',
      Success: 'Automation Rule edited successfully!',
      TransactionRulesError: 'Something went wrong. Please try again later.',
      RuleRequestError: 'Error setting up automation',
      TransactionRulesSuccess: 'Automation Rule created!',
      TransactionRulesMakerCheckerSuccess: 'Rule submitted for approval',
      TransactionRulesRequestError: 'Error setting up automation'
    },
    Cancel: 'Cancel',
    Back: 'Back',
    SaveAsDraft: 'Save as draft',
    Publish: 'Publish',
    Launch: 'Launch',
    Next: 'Next',

    RuleSetup: {
      Essentials: 'Essentials',
      Name: 'Name',
      NamePlaceholder: 'Type in your rule name here',
      Labels: 'Labels',
      LabelsPlaceholder: 'Type in your labels here',
      Partner: 'Partner',
      PartnerPlaceholder: 'Please select your partner',
      Owner: 'Owner',
      OwnerPlaceholder: 'Please select an owner',
      Mechanics: 'Mechanics',
      ValidityPeriod: 'Validity Period',
      TriggerLimits: 'Trigger Limits',
      TotalNumberofTriggerEvents: 'Total number of trigger events (on campaign level)',
      TotalNumberofTriggerEventsPerUser: 'Total number of trigger events (per user)',
      TriggerRateLimitPerUser: 'Trigger rate limit (per user)',
      TriggerRateLimitOnCampaignLevel: 'Trigger rate limit (on campaign level)',
      Days: 'Days',
      Weeks: 'Weeks',
      Months: 'Months',
      Years: 'Years',
      LimitTo: 'Limit to',
      TriggerEvent: 'trigger event(s)^ for every',
      UnlimitedTriggerEvents: 'Leave limit field blank for unlimited trigger events',
      Startdate: 'Start date',
      Enddate: 'End date',
      NoEnddate: 'No end date',
      SelectATrigger: 'Select a trigger:',
      SelectLoyaltyProgram: 'Select Loyalty Program',
      SelectNextTier: 'Select Next Tier',
      SelectCampaign: 'Select Campaign',
      Custom: 'Custom',
      Transaction: 'Transaction',
      Loyalty: 'Loyalty',
      Reward: 'Reward',
      Milestone: 'Campaign',
      Customer: 'Customer',
      Location: 'Location',
      SelectTrigger: 'Select Trigger',
      AgeingPointsHelp:
        'The number of points about to expire will be checked at the beginning of every review cycle.',
      AchievedNextTier: 'Achieved Next Tier',
      NearTier: '10% Close To Next Tier',
      PointsIssued: 'Points Issued',
      PointsEarnedorRedeemed: 'Points Earned or Redeemed',
      PointsEarnedOrRedeemed: 'Points Earned or Redeemed',
      SelectLoyaltyTransactionType: 'Select Loyalty Transaction Type',
      LoyaltyTransactionType: {
        earn: 'earn',
        burn: 'burn (redeem)'
      },
      LoyaltyConditions: {
        Attribute: {
          amount: 'Amount',
          transaction_properties: 'Has property'
        },
        Operator: {
          equals: 'equals',
          not_equals: 'not equals',
          greater_than: 'greater than',
          greater_than_or_equal_to: 'greater than or equal to',
          less_than: 'less',
          less_than_or_equal_to: 'less than or equal to',
          in: 'in',
          not_in: 'not in',
          contains: 'contains',
          not_contain: 'does not contain'
        }
      },
      AgeingPoints: 'Ageing points (points about to expire in the current cycle)',
      RedeemReward: 'Redeem Reward',
      IssueReward: 'Issue Reward',
      IssueRewardFromCampaign: 'Issue Reward From Campaign',
      IssueRewardFromMerchant: 'Issue Reward From Merchant',
      VoucherForParticularRewardExpiringIn: 'Voucher for particular Reward expiring in',
      AnyVoucherExpiringIn: 'Any voucher expiring in {days} days',
      StampRedeemed: 'Stamp Redeemed',
      StampsIssued: 'Stamps Issued',
      StampsInactive: 'Stamps Inactive',
      GamePlayed: 'Game Played',
      GameTryIssued: 'Game Try Issued',
      CampaignEnrolled: 'Campaign Enrolled',
      CampaignCompleted: 'Campaign Completed',
      CampaignNotCompleted: 'Campaign Not Completed',
      ProgressLevelAchieved: 'Progress Level Achieved',
      ProgressRuleTriggered: 'Progress Rule Triggered',
      QuestTaskCompleted: 'Quest Task Completed',
      SignUp: 'Sign-up',
      SignIn: 'Sign-In',
      ProfileUpdated: 'Profile Updated',
      LoyaltyProgramSelectPlaceholder: 'Select loyalty program',
      SelectTriggerPlaceholder: 'Please select a trigger'
    },

    MilestoneField: {
      SelectStampCampaign: 'Select a Stamp Campaign',
      Change: 'Change',
      Select: 'Select',
      StampCampaign: 'Stamp Campaign',
      AnyRewardsSelected:
        'Any {isCampaignRewardsSelected} rewards in this campaign will be a trigger',
      SelectStampsSlot: 'Select Stamps Slot',
      SelectStampPosition: 'Select Stamp Card Position'
    },

    CampaignSelectField: {
      Interval: 'Interval',
      Days: '(Days)',
      SelectStampCampaign: 'Select a Stamp Campaign',
      Change: 'Change',
      Select: 'Select',
      StampCampaign: 'Stamp Campaign',
      SelectACampaign: 'Select a Campaign',
      Edit: 'Edit',
      Add: 'Add',
      Campaign: 'Campaign',
      ID: 'ID',
      SelectAMilestone: 'Select a Milestone',
      SelectARule: 'Select a Rule',
      SelectATask: 'Select a Task'
    },

    GameSelectField: {
      SelectAGameCampaign: 'Select a Game Campaign',
      Game: 'Game',
      Campaign: 'Campaign',
      Change: 'Change',
      Select: 'Select'
    },

    CampaignRewardSelectField: {
      SelectACampaign: 'Select a Campaign',
      Change: 'Change',
      Select: 'Select',
      Campaign: 'Campaign',
      SelectAReward: 'Select a Reward (Optional)',
      Reward: 'Reward',
      ID: 'ID'
    },

    MerchantRewardSelectField: {
      SelectAMerchant: 'Select a Merchant',
      Change: 'Change',
      Select: 'Select',
      Merchant: 'Merchant',
      AddMerchant: 'Add Merchant',
      Cancel: 'Cancel',
      SearchMerchant: 'Search merchant by name or ID',
      Active: 'Active',
      Inactive: 'Inactive',
      ID: 'ID'
    },

    RewardSelectField: {
      SelectAReward: 'Select a Reward (Optional)',
      Change: 'Change',
      Reward: 'Reward',
      Select: 'Select',
      WarningText: 'Outcome Type is limited to [Push Event] when a System reward is selected'
    },

    RewardExpirySetupField: {
      SelectAReward: 'Select a Reward',
      Change: 'Change',
      Select: 'Select',
      Reward: 'Reward',
      Periods: 'Periods (Days)'
    },

    CheckInFields: {
      EnterLocationDetails: 'Enter Location Details',
      Latitude: 'Latitude',
      Longitude: 'Longitude',
      Radius: 'Radius',
      DegreesLatitude: 'Degrees (-90.0 to 90.0)',
      DegreesLongitude: 'Degrees (-180.0 to 180.0)',
      PermissibleRadiusInMeter: 'Permissible Radius (In Meter)',
      PermissibleRadius: 'Permissible Radius',
      Preview: 'PREVIEW'
    },

    OutcomeSection: {
      Outcome: 'Outcome:',
      MediaTagsToInclude: 'Media Tags To Include',
      SelectMediaTags: 'Select Media Tags',
      SelectLoyaltyProgram: 'Select Loyalty Program',
      SelectPointEarnType: 'Select Point Earn Type',
      FixedPoints: 'Fixed Points',
      VariablePoints: 'Variable Points',
      NumberOfPoints: 'Number of Points',
      PointsSignHint: '(Enter positive number to add points and negative number to deduct points.)',
      Award: 'Award',
      ForEvery: 'For Every',
      UpToAMaximumOf: 'Up to a maximum of',
      Currency: 'Currency',
      SelectGLAccount: 'Select GL Account',
      GLAccountName: 'GL Account Name',
      GLAccountNamePlaceholder: 'gl account name',
      Points: 'Points',
      GLAccountType: 'GL Account Type',
      GLAccountTypePlaceholder: 'gl account type',
      EnterKeyName: 'Enter key name',
      KeyName: 'Key name',
      EnterValueDetails: 'Enter value details',
      KeyValue: 'Key value',
      AddMore: 'Add More'
    },

    OutcomeList: {
      RemoveOutcome: 'Remove outcome at position {{position}}',
      MaxOutcomesReached: 'A rule can have at most 10 outcomes.',
      AddOutcome: 'Add Outcome',
      Position: 'Position {{position}}',
      Then: 'THEN:',
      SequentialExecutionNotice: 'Outcomes are executed sequentially',
      OutcomeIdMatchesType:
        'This outcome does not match the selected outcome type. Please select it again.'
    },

    OutcomeTypeField: {
      SelectOutcomeType: 'Select Outcome Type',
      Campaign: 'Campaign',
      Rewards: 'Rewards',
      Points: 'Points',
      Audience: 'Audience',
      UpdateCustomerDetails: 'Update Customer Details',
      PushEventOnly: 'Push Event Only',
      CustomFieldsTitle: 'Custom Fields',
      AddCustomField: '+ Add Custom Field',
      CustomFieldValidation: '{title} is required.',

      CustomFields: {
        Key: 'Key',
        Value: 'Value',
        CustomFieldsError: 'Please select correct custom fields!',
        UniqueKeyError: 'Key should be unique!'
      }
    },

    OutcomeCampaignSelectField: {
      SelectCampaignType: 'Select Campaign Type',
      Stamp: 'Stamp',
      Game: 'Game',
      Quiz: 'Quiz',
      Survey: 'Survey',
      SelectCampaign: 'Select a Campaign',
      Change: 'Change',
      Select: 'Select',
      Campaign: 'Campaign',
      BonusStamps: 'Bonus Stamps',
      BonusTries: 'Bonus Tries'
    },

    OutcomeRewardSelectField: {
      SelectReward: 'Select a Reward',
      Change: 'Change',
      Reward: 'Reward',
      Select: 'Select',
      OnlySystemRewardsShown: 'Only system rewards are shown.'
    },

    OutcomePointExpiry: {
      OutcomeExpiresAt: 'Outcome Expires At'
    },

    OutcomeAudienceField: {
      SelectAudienceList: 'Select Audience List',
      SelectAudienceListPlaceholder: 'Select Audience List'
    },

    LoyaltyAudience: {
      SelectAudience: 'Select an Audience',
      DefaultAudience: 'Create a single-use audience for this campaign',
      ExistingAudience: 'Select an existing audience',
      AudienceSetup: 'Audience Setup',
      SelectAudienceV4Placeholder: 'Select audience',
      SelectFilters: 'Select filters',
      SelectedFilters: 'Selected filters',
      NoFiltersSelected: 'No filters selected',

      AudienceListSetup: {
        Include: 'Include',
        Exclude: 'Exclude',
        AudienceExistsMessage: `Can't {{audienceIncludeExclude}} audience that's already set for {{audienceIncludeExcludeNoun}}`,
        PickAudienceList: 'Pick an audience list',

        Includes: 'Includes',
        Excludes: 'Excludes',
        AudienceWarningMessage:
          'The uploaded audience file will only be processed after it has been approved by a Bulk Actions Approver',
        SelectedFileForInclusion: 'Selected file for inclusion',
        AudienceNotInTheList: 'Audience not in the list',
        IncludeAudienceFilenamePlaceholder: 'Name the list of included audience',
        UploadNow: 'Upload now',
        UploadNewList: 'Upload New List',
        AcceptedFormat: 'Accepted Format: .xlsx/.csv files only.',
        DownloadSample: 'Download sample',
        UploadExclusion: 'Upload Exclusion',
        SelectedFileForExclusion: 'Selected file for exclusion',
        ExcludeAudienceFilenamePlaceholder: 'Name the list of excluded audience',

        SubmittingData: 'Submitting data...',
        SomethingWentWrong: 'Something went wrong.',
        AutoCreateCustomers: "Also create customers if they don't exist"
      },

      AudienceFilters: {
        Age: 'Age',
        BirthMonth: 'Birth Month',
        Gender: 'Gender',
        Location: 'Location',
        Loyalty: 'Loyalty',
        Personal: 'Personal',
        Custom: 'Custom',
        EmailTags: 'Email tags',
        Ethnicity: 'Ethnicity',
        SelectCustomerAttributeFilters: 'Select your customer-attribute filters:',
        NoFiltersSelected: 'No filters selected',
        And: 'and',
        Badge: 'Badge',
        Campaign: 'Campaign',
        Leaderboard: 'Leaderboard',
        LoyaltyPoints: 'Loyalty points',
        LoyaltyTier: 'Loyalty tier',
        MemberSince: 'Member since',
        Reward: 'Reward',
        Filter: 'Payment based',
        Payment: 'Payment',
        SelectFilters: 'Select filters to auto-generate an audience list',
        City: 'City',
        States: 'States',

        OfferId: 'Offer ID',
        PrimaryClusterComb: 'Primary Cluster Comb',
        PrimaryClusterState: 'Primary Cluster State',
        Membership: 'Member Of',
        CurrentBirthday: 'Only During Day Of Birth',
        CurrentBirthMonth: 'Only During Month Of Birth',
        HasBirthday: 'On Birthday',
        UserType: 'User Type',
        AccountConfirmedAt: 'Signed up between',
        LoyaltyPointsBalance: 'Points balance',
        CampaignEnrolment: 'Campaign',
        LeaderboardPosition: 'Leaderboard position',
        UPI: 'UPI',
        ScanPay: 'Scan pay',
        BBPS: 'BBPS',
        KYC: 'KYC',
        CurrentAddress: 'Current address',
        PaymentStatus: 'Payment status',
        PaymentBased: 'Payment based',
        DaysPastDues: 'Days past dues',
        BNPLUnpaidEMIDate: 'BNPL Unpaid EMI Date',
        InstaloanUnpaidEMIDate: 'Instaloan Unpaid EMI Date',

        AgeFilter: {
          Title: 'Age',
          Includes: 'Includes',
          Excludes: 'excludes',
          SelectPlaceholder: 'Includes',
          From: 'ages from',
          FromPlaceholder: '18',
          To: 'to',
          ToPlaceholder: '35',
          AddRange: 'Add range',
          And: 'and'
        },
        BirthdayFilter: {
          Title: 'Birthday',
          SelectBirthMonth: 'Select birth month',
          BirthMonth: 'Birth month',
          CurrentBirthMonth: 'Current Birth Month',
          OnlyDuringMonthOfBirth: 'Only During Month Of Birth',
          HasBirthday: 'Has Birthday',
          OnBirthday: 'On Birthday',
          Includes: 'Includes',
          Excludes: 'Excludes'
        },
        GenderFilter: {
          Title: 'Gender',
          SelectByGender: 'Select by Gender',
          Male: 'Male',
          Female: 'Female'
        },
        EthnicityFilter: {
          Title: 'Ethnicity',
          SelectEthnicity: 'Select ethnicity',
          SelectEthnicityPlaceholder: 'Select ethnicity',
          Include: 'Include',
          Exclude: 'Exclude',
          Includes: 'Includes',
          Excludes: 'excludes'
        },
        LocationFilter: {
          Title: 'Location',
          SelectCity: 'Select City',
          Include: 'Include',
          Exclude: 'Exclude',
          SelectCityPlaceholder: 'Select cities',
          SelectState: 'Select State',
          SelectStatePlaceholder: 'Select state',
          Includes: 'Includes',
          Excludes: 'Excludes'
        },

        PersonalFilter: {
          Title: 'Personal',
          HubClub: 'Hub Club',
          Select: 'Select',
          Include: 'Include',
          Exclude: 'Exclude',
          AddCustomProperties: 'Add custom properties',
          EnterKeyNameAndValueDetails: 'Enter key name and value details',
          SelectRelation: 'Select relation',
          EnterNumber: 'Enter number',
          KeyValue: 'Key value',
          DatePlaceholder: 'DD-MM-YYYY',
          KeyNamePlaceholder: 'Key name',
          Is: 'Is',
          True: 'True',
          False: 'False',
          And: 'AND',
          Or: 'OR',
          CustomAttributeType: 'Custom attribute #{{index}}: type',
          CustomAttribute: 'Custom attribute #{{index}}: attribute',
          CustomAttributeOperator: 'Custom attribute #{{index}}: operator',
          CustomAttributeValue: 'Custom attribute #{{index}}: value',
          Includes: 'includes',
          Excludes: 'excludes'
        },

        LoyaltyFilter: {
          Title: 'Loyalty',
          SelectLoyaltyProgram: 'Select Loyalty Program',
          Include: 'Include',
          Exclude: 'Exclude',
          SelectProgram: 'Select program',
          Includes: 'Includes',
          Excludes: 'Excludes',
          UsersWhoAchieved: 'Users who achieved',
          SelectProgramAndTier: 'Select program and tier',
          UsersWithPointsBalance: 'Users with points balance',
          SelectLoyaltyProgramPlaceholder: 'Select loyalty program',
          From: 'From',
          To: 'To',
          PointsBalanceFrom: 'Points balance from',
          PointsBalanceTo: 'Points balance to'
        },

        EmailTagsFilter: {
          Includes: 'Includes',
          SelectEmailTags: 'Select email tags',
          Excludes: 'Excludes'
        },

        PaymentBasedFilter: {
          IncludeUsersWith: 'Include users with',
          UPI: 'UPI',
          ScanPay: 'Scan pay',
          BBPS: 'BBPS',
          KYC: 'KYC',
          CurrentAddress: 'Current address',
          PaymentStatus: 'Payment status',
          DaysPastDues: 'Days past dues',
          BNPLUnpaidEMIDate: 'BNPL Unpaid EMI Date',
          InstaloanUnpaidEMIDate: 'Instaloan Unpaid EMI Date',
          SelectFromList: 'Select from list',
          SelectDate: 'Select Date',
          Upcoming: 'Upcoming',
          DueNow: 'Due now',
          Future: 'Future',
          Overdue: 'Overdue',
          None: 'None',
          Includes: 'Includes',
          Excludes: 'Excludes'
        }
      }
    },

    RuleDetail: {
      Title: 'Rule Detail',
      RuleName: 'Rule Name',
      Status: 'Status',
      StartTime: 'Start Time',
      EndTime: 'End Time',
      Labels: 'Labels',
      Notification: 'Notification',
      Owner: 'Owner',
      Partner: 'Partner',
      On: 'ON',
      Off: 'OFF',
      Merchant: 'Merchant',
      Trigger: 'Trigger',
      TriggerType: 'Trigger Type',
      TriggerEventName: 'Trigger Event Name',
      Conditions: 'Conditions',
      Campaign: 'Campaign',
      Reward: 'Reward',
      Loyalty: 'Loyalty',
      Tier: 'Tier',
      AutomationTrigger: 'Automation Trigger',
      TotalTriggerLimit: 'Total Trigger Limit',
      UserLifetimeLimit: 'User Lifetime Limit',
      TriggerLimitPerUser: 'Trigger Limit (per user)',
      TriggerLimitOnCampaignLevel: 'Trigger Limit (on campaign level)',
      Outcome: 'Outcome',
      OutcomeType: 'Outcome Type',
      OutcomeProperties: 'Outcome Properties',
      OutcomePropertyKey: 'Key',
      OutcomePropertyValue: 'Value',
      GLAccountNumber: 'GL Account Number',
      GLAccountName: 'GL Account Name',
      CostCenterId: 'Cost Center Id',
      BranchCode: 'Branch Code',
      AudienceInfo: 'Audience Info',
      TimesPerUser: 'Times Per',
      ID: 'ID'
    },

    CampaignDetail: {
      CampaignID: 'Campaign ID',
      CampaignName: 'Campaign Name',
      CampaignType: 'Campaign Type',
      BonusStamps: 'Bonus Stamps',
      BonusTries: 'Bonus Tries'
    },

    RewardDetail: {
      RewardID: 'Reward ID',
      RewardName: 'Reward Name'
    },

    LoyaltyDetail: {
      CampaignName: 'Campaign Name',
      Points: 'Points',
      OutcomeExpiresAt: 'Outcome Expires At',
      ForEvery: 'For Every',
      UpToAMaximumOf: 'Up to a maximum of'
    },

    LoyaltyTier: {
      NextTiers: 'Next Tiers',
      NextTier: 'Next Tier'
    },

    AutomationTrigger: {
      AutomationTrigger: 'Automation Trigger'
    },

    RuleRequestComment: {
      Content: 'Content',
      DeleteButton: 'Delete button',
      UserDescription: 'User Description',
      UserRole: 'User Role',
      Description: 'Description',
      Delete: 'Delete',
      Time: 'Time',
      PendingRule: 'Pending Rule',
      Approve: 'Approve',
      AddComment: 'Add Comment',
      ViewAndAddComments: 'View and add comments',
      ApproveRule: 'Approve rule',
      PendingRuleDescription:
        'This rule is pending reviews approval. Any comments added will show up here.',
      CommentsAdded: 'comments added'
    },

    DeleteCommentModal: {
      SuccessMessage: 'Comment deleted',
      ErrorMessage: 'Error deleting comment',
      Title: 'Delete comment?',
      OkText: 'Delete',
      DescriptionLineOne: 'Are you sure you want to delete your comment?',
      DescriptionLineTwo: 'This action cannot be undone.',
      CancelText: 'Cancel'
    },

    ApproveDenyCampaignRequestModalTitle: 'Approve campaign?',
    ApproveDenyCampaignRequestModalButton: 'Approve',

    ApproveDenyCampaignRequestModal: {
      SuccessMessage: 'Request has been approved',
      ErrorMessage: 'Something Went Wrong',

      ApproveTitle: 'Approve campaign?',
      Title: 'Submit deletion request?',
      ApproveOkText: 'Approve',
      OkText: 'Request deletion',
      CancelText: 'Cancel',

      ApproveDescriptionLineOne: 'Are you sure you want to approve this campaign?',
      ApproveDescriptionLineTwo: 'This action cannot be undone.',

      DescriptionLineOne: 'This rule is pending approval. Are you sure you want to delete it?',
      DescriptionLineTwo:
        'Once the deletion is approved, this rule will not be available and you will need to create it again.',
      ApproveRuleTitle: 'Approve rule?',
      SubmitDeletionRequestTitle: 'Submit deletion request?',
      RequestDeletionOkText: 'Request deletion',
      ApproveRuleDescriptionLineOne: 'Are you sure you want to approve this rule?',
      ApproveRuleDescriptionLineTwo: 'This action cannot be undone.'
    },

    AddCommentModalTitle: 'View and add comments',
    AddCommentModalButton: 'Add Comment',
    AddCommentModal: {
      SuccessMessage: 'Comment added',
      ErrorMessage: 'Error adding comment',
      CancelText: 'Cancel',
      CommentInputPlaceholder: 'Enter your comment here',
      AddCommentButton: 'Add comment'
    },

    AudienceInfoTitle: 'Audience Info',

    AudienceInfo: {
      Description: 'Selected audience:',
      NoListsSelected: 'No lists selected',
      Include: 'Include',
      Exclude: 'Exclude',
      AudienceAttributes: 'Audience attributes',
      AudienceList: 'Audience list',
      NoFiltersSelected: 'No filters selected'
    },

    AudienceInfoFilters: {
      Loyalty: 'Loyalty',
      Gender: 'Gender',
      Age: 'Age',
      BirthMonth: 'Birth Month',
      Ethnicity: 'Ethnicity',
      City: 'City',
      States: 'States',
      OfferId: 'Offer Id',
      PrimaryClusterComb: 'Primary Cluster Comb',
      PrimaryClusterState: 'Primary Cluster State',
      MemberOf: 'Member Of',
      OnlyDuringDayOfBirth: 'Only During Day Of Birth',
      OnlyDuringMonthOfBirth: 'Only During Month Of Birth',
      OnBirthday: 'On Birthday',
      UserType: 'User Type',
      EmailTags: 'Email Tags',
      SignedUpBetween: 'Signed up between',
      Reward: 'Reward',
      Badge: 'Badge',
      PointsBalance: 'Points balance',
      Campaign: 'Campaign',
      LeaderboardPosition: 'Leaderboard position',
      Upi: 'UPI',
      ScanPay: 'Scan pay',
      Bbps: 'BBPS',
      Kyc: 'KYC',
      CurrentAddress: 'Current address',
      PaymentStatus: 'Payment status',
      DaysPastDues: 'Days past dues',
      BnplUnpaidEmiDate: 'BNPL Unpaid EMI Date',
      InstaloanUnpaidEmiDate: 'Instaloan Unpaid EMI Date'
    }
  }
};
